import styled from "@emotion/styled"
import { Dialog } from "radix-ui"
import { TbInfoCircle } from "@react-icons/all-files/tb/TbInfoCircle"
import { Value } from "@stringtale/react"
import { ContentSubjectType } from "db/enums"
import { useMemo, useState } from "react"
import { DIMMED_BLUE_COLOR } from "theme/colors"
import { PX12, PX14 } from "theme/sizes"
import Group from "ui/Group"
import Stack from "ui/Stack"
import Text from "ui/Text"
import getContentSubjectColor from "web/src/content-subjects/getContentSubjectColor"
import Image from "web/src/files/components/Image"
import { TParticipantsIcons } from "web/src/learning-lines/types"
import ParticipationIconModalContent from "./ParticipationIconModalContent"
import { AnimatePresence } from "framer-motion"

const Title = styled.h2<{ contentSubjectType: ContentSubjectType }>`
  font-size: ${PX14};
  font-weight: 700;
  color: ${(p) => getContentSubjectColor(p.contentSubjectType)};
  letter-spacing: 0.28px;
`

const ModalTrigger = styled(Group)`
  cursor: pointer;
`

export type LessonType = {
  contentSubject: ContentSubjectType
  subjects: {
    subjects: {
      participationIcons: TParticipantsIcons[]
    }[]
  }[]
}

const ParticipationIcons = ({ lesson }: { lesson: LessonType }) => {
  const [modalOpen, setModalOpen] = useState(false)

  const participantsIcons = useMemo(() => {
    if (!lesson || !lesson.subjects) return
    const map = new Map<number, TParticipantsIcons>()
    lesson.subjects.forEach((headSubjectGroup) => {
      headSubjectGroup.subjects.forEach((headSubject) => {
        headSubject.participationIcons.forEach((icon) => {
          map.set(icon.id, icon)
        })
      })
    })
    return [...map.values()].sort((a, b) => a.order - b.order)
  }, [lesson])
  if (!participantsIcons) return <></>

  return (
    <Stack gap="8px">
      <Dialog.Root open={modalOpen} onOpenChange={setModalOpen}>
        <AnimatePresence>
          {modalOpen && <ParticipationIconModalContent />}
        </AnimatePresence>
      </Dialog.Root>
      {/* setModalOpen */}
      <ModalTrigger gap="4px" align="center" onClick={() => setModalOpen(true)}>
        <Title contentSubjectType={lesson.contentSubject}>
          <Value name="apps.web.src.lessons.components.participationicons.meedoen">
            Meedoen
          </Value>
        </Title>
        <TbInfoCircle
          size={16}
          strokeWidth={2.5}
          color={getContentSubjectColor(lesson.contentSubject)}
        />
      </ModalTrigger>

      <Stack gap="6px">
        {participantsIcons.map((icon) => (
          <Group gap="12px" align="center" justify="flex-start">
            {icon.image ? (
              <Image
                file={icon.image}
                width={20}
                height={20}
                options={{ fit: "contain" }}
                alt=""
              />
            ) : null}
            <Text color={DIMMED_BLUE_COLOR} size={PX12}>
              {icon.displayTitle}
            </Text>
          </Group>
        ))}
      </Stack>
    </Stack>
  )
}

export default ParticipationIcons
